import { Injectable } from '@angular/core';
import { State, Action, StateContext, Selector } from '@ngxs/store';
import { UpdateInboxBadgeCount } from './task-management.actions';

export class TaskManagementStateModel {
  inboxCount: number;
}

@State<TaskManagementStateModel>({
  name: 'taskManagement',
  defaults: {
    inboxCount: 0
  }
})

@Injectable()

export class TaskManagementState {

  @Selector()
  static inboxCount(state: TaskManagementStateModel) {
    return state.inboxCount;
  }

  constructor(
  ) {}

  @Action(UpdateInboxBadgeCount, { cancelUncompleted: false})
  updateInboxBadgeCount({ patchState }: StateContext<TaskManagementStateModel>, { newCount }) {
      return patchState({ inboxCount: newCount });
  }
}
